module.exports = __webpack_public_path__ + "img/SSP.70c526bb.png";